import { useState } from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import { AuthContext } from '../context/AuthContext';
import firebase from "firebase/app";
import firebaseConfig from "../config/firebase";
import Login from "./Login";
import Register from "./Register";
import Tours from "./Tours";
import TourEdit from "./TourEdit";
import TourSummary from "./TourSummary";
import GigSalesData from "./GigSalesData";
import GigFinancialData from "./GigFinancialData";
import SalesInput from "./SalesInput";
import "../styles/App.css";
import Header from "./Header";
import ConfirmTourDeletion from "./ConfirmTourDeletion";
import ConfirmGigDeletion from "./ConfirmGigDeletion";
import ConfirmProductDeletion from "./ConfirmProductDeletion";
import TourUsers from "./TourUsers";
import ConfirmUserRoleDeletion from "./ConfirmUserRoleDeletion";

firebase.initializeApp(firebaseConfig);

function App() {

  const [user, setUser] = useState(null);

  return (
    <Router>
      <AuthContext.Provider value={{ user, setUser }}>
        <Header />
        <Switch>
          <Route exact path="/">
            <Tours />
          </Route>
          <Route exact path='/tour/:tourId'>
            <TourSummary />
          </Route>
          <Route exact path='/tour/:tourId/gig/:gigId/sales'>
            <GigSalesData />
          </Route>
          <Route exact path='/tour/:tourId/gig/:gigId/sales/:salesId'>
            <SalesInput />
          </Route>
          <Route exact path='/tour/:tourId/gig/:gigId/finance'>
            <GigFinancialData />
          </Route>
          <Route exact path='/tour/:tourId/users'>
            <TourUsers />
          </Route>
          <Route path="/login">
            <Login />
          </Route>
          <Route path="/register">
            <Register />
          </Route>
          <Route exact path="/delete/tour/:tourId">
            <ConfirmTourDeletion />
          </Route>
          <Route exact path="/delete/tour/:tourId/gig/:gigId">
            <ConfirmGigDeletion />
          </Route>
          <Route exact path="/delete/tour/:tourId/product/:productId">
            <ConfirmProductDeletion />
          </Route>
          <Route exact path="/delete/tour/:tourId/userRole/:userId">
            <ConfirmUserRoleDeletion />
          </Route>
          <Route path="/edit/:tourId">
            <TourEdit />
          </Route>
        </Switch>
      </AuthContext.Provider>
    </Router>
  );
}

export default App;
